import SectionEditDialog from "../SectionEditDialog";
import AssessmentReportSectionEditInputs from "./AssessmentReportSectionEditInputs";
import { validateAssessmentReportSection } from "./validation";
import type {
  AssessmentReportSectionEditModalProps,
  AssessmentReportSectionId,
} from "../../../types";

const sectionTitles: Record<AssessmentReportSectionId, string> = {
  text: "Text",
  images: "Images",
  data: "Data",
};

function AssessmentReportSectionEditModal(
  props: AssessmentReportSectionEditModalProps,
) {
  if (!props.section) return null;
  return (
    <SectionEditDialog
      {...props}
      title={sectionTitles[props.section]}
      testId="assessment-report-section-edit-modal"
      maxWidth="lg"
      validate={(values) =>
        validateAssessmentReportSection(props.section!, values)
      }
    >
      <AssessmentReportSectionEditInputs section={props.section} />
    </SectionEditDialog>
  );
}

export default AssessmentReportSectionEditModal;
